/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ReportDeeplinkRequest} from '@cash-web/protos/squareup/franklin/app/report_deeplink.pb'
import {ReportDeeplinkResponse} from '@cash-web/protos/squareup/franklin/app/report_deeplink.pb'


export const reportDeeplink = (request:ReportDeeplinkRequest, options?: CashRequestOptions) => post<ReportDeeplinkRequest, ReportDeeplinkResponse>("/2.0/cash/report-deeplink", request, {...options, rejectOnError: true })